import React from 'react';
import { Row as TRow } from '@tanstack/react-table';
import { TApplication } from 'lendingApi/applications.types';
import styles from '../ApplicationsTable.module.css';
import { Cell } from '../Cells/Cell';

type TProps = {
  row: TRow<TApplication>;
  virtualRowHeight: number;
  handleRowClick: (application: TApplication) => void;
};

export const Row = React.memo(
  ({ row, virtualRowHeight, handleRowClick }: TProps) => {
    const onClick = React.useCallback(
      () => handleRowClick(row.original),
      [handleRowClick, row.original],
    );
    return (
      <tr
        key={row.id}
        className={styles.row}
        style={{ height: `${virtualRowHeight}px` }}
        onClick={onClick}
      >
        {row.getVisibleCells().map((cell) => (
          <Cell key={cell.id} cell={cell} />
        ))}
      </tr>
    );
  },
);

Row.displayName = 'Row';
